import React from "react";
import { Button, Stack } from "@mui/material";
import type { PartModel } from "./specsModel/PartModel";

type PartPickerLeftMenuProps = {
  parts: PartModel[];
  selectedPartName: string;
  footerActionLabel?: string;
  onFooterAction?: () => void;
  onSelectPart: (partName: string) => void;
};

export default function PartPickerLeftMenu({
  parts,
  selectedPartName,
  footerActionLabel,
  onFooterAction,
  onSelectPart,
}: PartPickerLeftMenuProps) {
  return (
    <Stack spacing={1}>
      {parts.map((part) => {
        const selected = part.name === selectedPartName;

        return (
          <Button
            key={part.name}
            variant="text"
            color="inherit"
            onClick={() => onSelectPart(part.name)}
            sx={{
              justifyContent: "space-between",
              minHeight: 36,
              textAlign: "left",
              typography: "button",
              bgcolor: selected ? "primary.main" : "transparent",
              textDecoration: "none!important",
              "& span": {
                color: selected ? "white" : "primary.main",
                p: 2,
              },
              "&:hover": {
                bgcolor: selected ? "primary.dark" : "action.hover",
              },
            }}
          >
            <span>{part.name}</span>
            <span>{part.elements.length}</span>
          </Button>
        );
      })}

      {footerActionLabel && onFooterAction ? (
        <Stack direction="row" justifyContent="flex-end">
          <Button size="small" variant="contained" onClick={onFooterAction}>
            {footerActionLabel}
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
}
